//import { Layout } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import { styled } from 'styled-components';
import { RulesItem } from '~/components/ui/rules-item';

type Props = {
  setIsRulesNotSeen?: Dispatch<SetStateAction<boolean>>;
};

function GameFooter({ setIsRulesNotSeen }: Props) {
  return (
    <Container>
      <RulesItem
        onClick={() => setIsRulesNotSeen && setIsRulesNotSeen((prev) => !prev)}
      />
    </Container>
  );
}

export default GameFooter;

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  min-height: 40px;
  width: 100%;
  z-index: 2;
  padding: 5px;
  pointer-events: none;

  @media screen and (max-width: 450px) {
    padding: 5px;
  }
  @media screen and (max-height: 800px) {
    padding: 5px;
  }
  @media screen and (max-height: 450px) {
    padding: 5px;
  }
`;
